import app from 'app';

// TODO: This seems like a good candidate to move to a shared service.
// It was copied from Admin portal.
function UploadFile($q, Api) {
  function reserveS3Url(contentType) {
    return Api.post('/document/member_submitted/url', { contentType });
  }

  function uploadToZendesk(file) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return Api.req({
      method: 'POST',
      endPoint: '/crmclient/inbox/upload',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  function uploadToS3(file, url) {
    return Api.req({
      method: 'PUT',
      endPoint: url,
      data: file,
      headers: {
        'Content-Type': file.type,
        'x-amz-server-side-encryption': 'AES256',
      },
    });
  }

  function uploadFileToZendesk(file) {
    if (!file) {
      return $q.reject('Must provide a file to upload.');
    }

    return uploadToZendesk(file).then(function (response) {
      return response.upload.token;
    });
  }

  function uploadMultipleToZendesk(files) {
    return $q.all(files.map(uploadFileToZendesk));
  }

  function uploadFile(file) {
    if (!file) {
      return $q.reject('Must provide a file to upload.');
    }

    return reserveS3Url(file.type).then(function (reservedS3Location) {
      return uploadToS3(file, reservedS3Location.url).then(function () {
        return reservedS3Location.path;
      });
    });
  }

  function uploadMultiple(files) {
    return $q.all(files.map(uploadFile));
  }

  return {
    uploadFile,
    uploadMultiple,
    uploadFileToZendesk,
    uploadMultipleToZendesk,
  };
}

app.service('UploadFile', UploadFile);
